import { render, staticRenderFns } from "./EstatusSolicitud.vue?vue&type=template&id=5f1c95f6"
import script from "./EstatusSolicitud.vue?vue&type=script&lang=js"
export * from "./EstatusSolicitud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports